export default "__VITE_ASSET__BLkEuagj__"